// extracted by mini-css-extract-plugin
export default {"ReviewContainer":"Review_ReviewContainer__1VuWu","CardContainer":"Review_CardContainer__ZxkQx","userImg":"Review_userImg__e7q4b","CardContainerTwo":"Review_CardContainerTwo__zpb-x"};